export function notNullOrUndefined(x) {
    return x !== null && x !== undefined;
}
export function notNull(x) {
    return x !== null;
}
export function notUndefined(x) {
    return x !== undefined;
}
//# sourceMappingURL=notNullOrUndefined.js.map